var indentation_default = {
  "indentZero": "KdLlf",
  "indentOne": "nZLUA",
  "indentTwo": "rj4cO",
  "indentThree": "R-y8H",
  "indentFour": "nE6dN",
  "indentFive": "YviMT",
  "indentSix": "nZLjH"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
